<app-invoice-form [editable]="false" [invoiceId]="invoiceId | async" [patientGuid]="patientGuid | async">
</app-invoice-form>
